import useStyles from 'isomorphic-style-loader/useStyles';
import React, { useCallback, useRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isDesktop } from '../utils/platform';
import { dispatchSkyfireMethods } from '../utils';
import { useInView } from '../utils/useItemsInView';
import useTimeout from '../utils/useTimeout';
import * as Styles from './Notification.scss';
import { RMX_BROWSER_DEVICE_TYPES } from '../utils/deviceTypes';
import { globals } from '../utils/globals';
export default function NotificationToast(props) {
    useStyles(Styles);
    const dispatch = useDispatch();
    const toast = useSelector((state) => state.Toast.toast);
    const mediaId = useSelector((state) => state.Media.mediaId);
    const overlayTemplates = useSelector((state) => state.TemplateStack.overlayTemplates);
    const iOSMShopBottomOverride = useSelector((state) => state.MShop.iOSMShopBottomOverride);
    const enableIOSMShopBottomOverride = useSelector((state) => state.MShop.enableIOSMShopBottomOverride);
    const [mobileTransportBottom, setMobileTransportBottom] = useState(85);
    const [iosBottomOverride, setIosBottomOverride] = useState(0);
    const timerRef = useRef(null);
    const hasOverlay = overlayTemplates.length > 0;
    const closeCallback = useCallback((event) => {
        if (!toast)
            return;
        event === null || event === void 0 ? void 0 : event.preventDefault();
        dispatchSkyfireMethods(dispatch, props.template, toast.onClosed);
    }, [dispatch, toast]);
    const onItemSelectedCallback = useCallback((event) => {
        if (!toast)
            return;
        event === null || event === void 0 ? void 0 : event.preventDefault();
        const { onItemSelected } = toast;
        dispatchSkyfireMethods(dispatch, props.template, onItemSelected);
    }, [dispatch, toast]);
    useEffect(() => {
        if (enableIOSMShopBottomOverride) {
            const bottomValue = iOSMShopBottomOverride + 85;
            setMobileTransportBottom(bottomValue);
            setIosBottomOverride(iOSMShopBottomOverride);
        }
        else {
            setMobileTransportBottom(85);
            setIosBottomOverride(0);
        }
    }, [enableIOSMShopBottomOverride]);
    useTimeout(toast, timerRef, closeCallback, toast === null || toast === void 0 ? void 0 : toast.timeoutMilliseconds);
    const onViewed = useCallback(() => {
        if (toast === null || toast === void 0 ? void 0 : toast.onViewed) {
            dispatchSkyfireMethods(dispatch, props.template, toast.onViewed);
        }
    }, [dispatch, toast === null || toast === void 0 ? void 0 : toast.onViewed]);
    const callbackRef = useInView(onViewed);
    if (!toast ||
        (hasOverlay &&
            overlayTemplates[0].interface !== props.template.interface &&
            !props.isNowPlaying)) {
        return null;
    }
    let transportHeight;
    if (!isDesktop(window)) {
        transportHeight = props.isNowPlaying ? iosBottomOverride : mobileTransportBottom;
    }
    else {
        transportHeight = props.isNowPlaying ? 125 : 85;
    }
    const bottomPosition = mediaId ? transportHeight : iosBottomOverride;
    const { deviceType } = globals.amznMusic.appConfig;
    const notificationToastClassName = [
        'hydrated',
        toast.navigationIcon ? Styles.linkNotification : null,
        RMX_BROWSER_DEVICE_TYPES.includes(deviceType) ? Styles.rwpZIndexOverride : '',
    ].join(' ');
    return (React.createElement("music-notification-toast", { className: notificationToastClassName, onClick: onItemSelectedCallback, onMouseEnter: () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        }, onMouseLeave: () => {
            timerRef.current = setTimeout(() => {
                closeCallback();
            }, toast.timeoutMilliseconds);
        }, ref: callbackRef, style: {
            bottom: `${bottomPosition}px`,
        }, kind: "accent", statusIconName: toast.statusIcon, navigationIconName: toast.navigationIcon }, toast === null || toast === void 0 ? void 0 : toast.message));
}
